import _ from 'lodash';
import { CompositionChangeType, CompositionActionType, FlightDependencyItemLevel, } from '../Composition.types';
import { AsyncRequestStatus } from '@ane/core/lib/models';
import { compareIgnoreCase } from '@ane/core/lib/utils/CommonStringUtils';
export const convertFlightDependencies = (rootFlightName, flightEditResponse) => {
    const relatedFlights = _.map(flightEditResponse.FlightEditResponseItems, (responseItem) => {
        return {
            name: responseItem.FlightName,
            isolationGroups: flightEditResponse.FlightIsolationGroupsMap[responseItem.FlightName] || [],
            isRunning: flightEditResponse.FlightRunningStatusMap[responseItem.FlightName] || false,
            dependencies: [
                { severityLevel: responseItem.SeverityLevel, message: responseItem.Message, itemType: responseItem.ItemType },
            ],
            composition: convertFlightCompositionMap(flightEditResponse.FlightCompositionMap[responseItem.FlightName], flightEditResponse),
        };
    });
    return moveRootFlightToTop(rootFlightName, relatedFlights, flightEditResponse);
};
export const moveRootFlightToTop = (rootFlightName, dependencies, flightEditResponse) => {
    const rootFlightIndex = _.findIndex(dependencies, (d) => compareIgnoreCase(d.name, rootFlightName));
    if (rootFlightIndex < 0) {
        const rootFlight = {
            name: rootFlightName,
            isolationGroups: flightEditResponse.FlightIsolationGroupsMap[rootFlightName],
            isRunning: flightEditResponse.FlightRunningStatusMap[rootFlightName],
            composition: convertFlightCompositionMap(flightEditResponse.FlightCompositionMap[rootFlightName], flightEditResponse),
            dependencies: [],
        };
        return [rootFlight].concat(dependencies);
    }
    else {
        return [dependencies[rootFlightIndex], ...dependencies.slice(0, rootFlightIndex), ...dependencies.slice(rootFlightIndex + 1)];
    }
};
export const convertFlightCompositionMap = (composition, flightEditResponse) => {
    return _.map(composition, (child) => {
        var _a;
        return {
            flightName: child.FlightName,
            forceAssignOnNumberline: child.ForceAssignOnNumberline,
            isRunning: (_a = flightEditResponse.FlightRunningStatusMap[child.FlightName]) !== null && _a !== void 0 ? _a : false,
            availableAction: CompositionActionType.Remove,
            change: CompositionChangeType.None,
            isInExistingComposition: true,
        };
    });
};
export const validateComposition = (composition, flightQueries) => {
    const errors = [];
    const newlyAddedFlights = _.filter(composition, (c) => c.change === CompositionChangeType.Added);
    const failedQueries = _.filter(newlyAddedFlights, (f) => { var _a; return ((_a = flightQueries[f.flightName]) === null || _a === void 0 ? void 0 : _a.status) === AsyncRequestStatus.Failed; });
    if (failedQueries.length > 0) {
        errors.push(`Flight ${failedQueries[0].flightName} does not exist. Flight must be registered before it can be composed.`);
    }
    const childFlightNames = _.map(composition, (c) => c.flightName);
    if (new Set(childFlightNames).size !== childFlightNames.length) {
        errors.push('Composition contains duplicate children.');
    }
    return errors;
};
export const buildCompositionUpdateRequest = (flightId, flightCompositions) => {
    const requestItems = _.map(Object.keys(flightCompositions), (flightName) => {
        const filteredCompositions = _.filter(flightCompositions[flightName], (c) => c.change !== CompositionChangeType.Removed);
        const compositionChildren = _.map(filteredCompositions, (c) => {
            var _a;
            return {
                FlightName: c.flightName,
                ForceAssignOnNumberline: (_a = c.forceAssignOnNumberline) !== null && _a !== void 0 ? _a : false,
            };
        });
        return {
            FlightName: flightName,
            CompositionChildren: compositionChildren,
        };
    });
    return {
        SelectedFlight: flightId,
        RequestItems: requestItems,
    };
};
export const isResultBlocking = (flightEditResponse) => {
    return _.some(flightEditResponse === null || flightEditResponse === void 0 ? void 0 : flightEditResponse.FlightEditResponseItems, (item) => item.SeverityLevel >= FlightDependencyItemLevel.Blocking);
};
export const resultBlockingMessage = (flightEditResponse) => {
    var _a, _b;
    return ((_b = (_a = _.find(flightEditResponse === null || flightEditResponse === void 0 ? void 0 : flightEditResponse.FlightEditResponseItems, (item) => item.SeverityLevel >= FlightDependencyItemLevel.Blocking)) === null || _a === void 0 ? void 0 : _a.Message) !== null && _b !== void 0 ? _b : 'No Error information present');
};
export const getSubmissionResultMessage = (isVerificationSuccess, error) => {
    if (isVerificationSuccess) {
        return 'The changes were successfully committed. The changes may take up to 30 minutes before they are reflected in the composition and experiments.';
        // } else if (submitWithBlocking) {
        //    return "The changes were successfully committed.The changes may take up to 30 minutes before they are reflected in the composition and experiments. You chose to submit changes without resolving all inconsistencies. This means that some experiments may not be able to start or advance without further changes.";
    }
    else {
        return 'The proposed changes have blocking issues. The changes were not successfully committed. Error: ' + error;
    }
};

//# sourceMappingURL=CompositionEdit.utils.js.map
